// 获取当前symbol
export function getActiveSymbol({ home }) {
  return home.activeSymbolItem;
}
// 获取当前主题色
export function getNowTheme({ home }) {
  return { mainColor: home.mainColor, contentColor: home.contentColor,lang:home.lang };
}

// 获取当前symbol
export function getAgentConfig({ home }) {
  return home.agentConfig;
}